"use strict";require('@ebay/skin/drawer-dialog');